<div class="mt-3" *ngIf="!loadingComponent">
    <eess-bienvenido></eess-bienvenido>
    <div class="row d-flex jc-c">
        <div class="bch-card col-11 col-md-9 col-lg-7 pa-lg-5">
            <div class="row mb-5 jc-c">
                <div class="col-12 col-md-9 mx-md-auto">
                    <p class="ta-c c-brand text--default d-md-none px-3 pt-3" [innerHTML]="infoIdentidad"> </p>
                    <p class="ta-c c-brand text--medium d-none d-md-block" [innerHTML]="infoIdentidad"> </p>
                </div>
            </div>
            <div class="row">
                <div class="col-12 ta-c px-md-5 pb-0">
                    <form [formGroup]="form">
                        <div class="row d-flex jc-c">
                            <div class="bch-input col-11 col-md-8 px-md-0">
                                <mat-form-field appearance="outline">
                                    <input formControlName="rut" (keyup)=rutFormater() (click)="activeSerialInformation = false"
                                        matInput type="text" placeholder="RUT" maxlength="12" required />
                                    <mat-error *ngIf="form.get('rut').hasError('rut')">Debe ingresar un rut válido.</mat-error>
                                </mat-form-field>

                            </div>
                            <div class="col-11 d-md-flex jc-c mb-5">
                                <!-- CARD DOCUMENT INFORMATION -->
                                <fenix-document-information-card #documentRef *ngIf="activeSerialInformation">
                                </fenix-document-information-card>
                            </div>
                            <div class="bch-input col-11 col-md-8 px-md-0">
                                <mat-form-field appearance="outline" (click)="activeSerialInformation = true">
                                    <mat-label>Nº documento / Nº de serie</mat-label>
                                    <input (focus)="activeSerialInformation = true" formControlName="cedula" matInput autocomplete="off" maxlength="11"
                                        directiveFormatoNumeroDocumento="3" />
                                    <mat-error *ngIf="!formulario['cedula'].errors?.required && formulario['cedula'].errors?.invalidSerial">
                                        Número de serie no tiene el formato correcto
                                    </mat-error>
                                    <mat-error *ngIf="formulario['cedula'].errors?.required && formulario['cedula'].touched">Debe completar este
                                        campo.</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </form>
        
                    <div class="col-12 col-md-9 mx-md-auto px-md-2 my-3 bch-button-auto-size">
                        <bch-button [disabled]="form.invalid || load" [button]="buttonContinuar" (clicked)="validateFormAndExecuteCaptcha()"></bch-button>
                    </div>
        
                    <div class="contedor-texto-captcha">
                        <span class="texto texto-reCaptcha">Protegido por reCAPTCHA</span>
                        <span class="texto texto-normal"> -
                            <a [href]="privacidad">Privacidad</a> -
                            <a [href]="condiciones">Condiciones</a>
                        </span>
                    </div>
                </div>
                <div class="col-12">
                    <bch-alert *ngIf="errorServicioEquifax" 
                                type="alert-warning"
                                class="mb-3 bch-alert--small"
                                hideIcon = false
                                title="{{errorServicioEquifax}}">
                    </bch-alert>
                </div>
            </div>
        </div>   
    </div>
</div>
<app-loading *ngIf="loadingComponent"></app-loading>